const IS_DEV = process.env.NODE_ENV !== 'development' ? false : false; // true : backup, false: production
export const API_URL_BASE = IS_DEV
  ? 'http://192.168.1.100:8000/api'
  : 'https://api.pos-app.net/api';
export const IMAGE_BASE_URL = IS_DEV
  ? 'http://192.168.1.100:8000/upload'
  : 'https://api.pos-app.net/upload';
export const HOST_COLLECTION_URL = IS_DEV
  ? 'http://host-collection.com:8300'
  : 'https://cdn.pos-app.net';

export const SOCKET_SERVER = IS_DEV ? 'http://160.251.15.118:9005' : 'https://realtime.pos-app.net';

export const DEFAULT_APP_NAME = 'web_scan_qr_show_menu';

export const ENCODE_SECRET_KEY = process.env?.ENCODE_SECRET_KEY || 'QiLCJhbGciOiJSUzI';
